exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-collection[data-v-1997e444] {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 auto;\n  justify-content: center;\n  align-items: stretch;\n  padding: 58px 56px 33px 56px;\n}\n.search-collection .search-results-found[data-v-1997e444] {\n  width: 100%;\n  text-align: center;\n  margin-bottom: 35px;\n}\n.search-collection .search-result[data-v-1997e444] {\n  margin: 15px;\n}\n.message-wrap[data-v-1997e444] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 400px;\n}", ""]);

// exports
